import { defineComponent as _defineComponent } from 'vue';
import Authenticated from "./Authenticated.vue";
import AdministratorMenu from "@/Components/Navigation/AdministratorMenu.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Admin',
    props: {
        title: {
            type: String,
            default: "",
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const __returned__ = { props, Authenticated, AdministratorMenu };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
